// extracted by mini-css-extract-plugin
module.exports = {"c1pm4798":"c1pm4798"};